import React from 'react';
import { CardsPage } from './components/be/CardsPage';
// import {IntlProvider} from 'enzyme-react-intl';


function App() {
  return (
    <div className="App">
      {/* <IntlProvider locale="en"> */}
        <CardsPage/>
      {/* </IntlProvider> */}
    </div>
  );
}

export default App;
